import axios from 'axios'
import { getServerToken, invalidateServerToken } from '$lib/auth.svelte'

export function requestServer(
  currentServer: any,
  method: string,
  path: string,
  data: any
) {
  return Promise.any(
    currentServer.urls.map(async (baseURL: string) => {
      const attempt = async (retry: boolean): Promise<any> => {
        const token = await getServerToken(currentServer.uid)
        try {
          return await axios({
            method,
            url: `${baseURL}/${path}`,
            data,
            headers: {
              "Authorization": `Bearer ${token}`
            },
            // withCredentials: true
          })
        } catch (error: any) {
          // Token expired/invalid for this server: re-mint once and retry.
          if (error?.response?.status === 401 && retry) {
            invalidateServerToken(currentServer.uid)
            return attempt(false)
          }
          throw error
        }
      }
      return attempt(true)
    })
  )
}
